import TaxonomyAdminScreen from "../taxonomy/taxonomy-admin-screen.tsx";

export default function GenresScreen() {
  return <TaxonomyAdminScreen type="genres" title="ژانرها" />;
}
